module.exports = __webpack_public_path__ + "static/media/the-man-called-GOD.771cc845.md";